import React from 'react';
import './ObservacoesAtendimento.css';

interface ObservacoesAtendimentoProps {
  observacoesCliente?: string | null;
  observacoesOficina?: string | null;
}

/**
 * Bloco de leitura das observações do atendimento (at-54): "Observações do
 * Cliente" (o que o cliente relatou/pediu) e "Observações da Oficina"
 * (anotações internas da equipe), gravadas no cadastro/edição do veículo.
 *
 * Compartilhado pelos modais de placa de todos os papéis (Recepção, Chefe,
 * Administração, Tela de Controle, Home e Tempo e SLA). Não renderiza nada
 * quando as duas estão vazias.
 */
const ObservacoesAtendimento: React.FC<ObservacoesAtendimentoProps> = ({
  observacoesCliente,
  observacoesOficina,
}) => {
  if (!observacoesCliente && !observacoesOficina) return null;

  return (
    <div className="observacoes-atendimento">
      {observacoesCliente && (
        <div className="observacoes-atendimento-bloco">
          <span className="observacoes-atendimento-label">Observações do Cliente</span>
          <p className="observacoes-atendimento-texto">{observacoesCliente}</p>
        </div>
      )}
      {observacoesOficina && (
        <div className="observacoes-atendimento-bloco">
          <span className="observacoes-atendimento-label">Observações da Oficina</span>
          <p className="observacoes-atendimento-texto">{observacoesOficina}</p>
        </div>
      )}
    </div>
  );
};

export default ObservacoesAtendimento;
